/* 🤖 this file was generated by svg-to-ts */
export const emperorIconShoppingCart1: {
  name: 'shopping_cart_1';
  data: string;
} = {
  name: 'shopping_cart_1',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M18 2c-.47 0-.87.32-.98.77l-.98 4.225H2.98c-.31 0-.6.14-.79.38 -.19.242-.26.56-.19.85l2 8c.11.44.51.75.97.75h10c.46 0 .86-.33.97-.78l2.82-12.23h3.2v-2h-4Zm-2.42 7l-.47 2H4.76l-.5-2h11.308Zm-9.808 6l-.5-2h9.38l-.47 2H5.75Z"/><path d="M6 18a2 2 0 1 0 0 4 2 2 0 1 0 0-4Z"/><path d="M14 18a2 2 0 1 0 0 4 2 2 0 1 0 0-4Z"/></g></svg>`,
};
